module.exports = __webpack_public_path__ + "img/logo_pvbki_ukr.e1990951.png";